/* eslint-disable react/prop-types */ // TODO: add props
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

const Attachment = ({ attachment, onClick }) => (
  <div className="attachment">
    <a
      href={attachment.get('url')}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      {attachment.get('attachment_type') === 'link' ? (
        <i className="icon-share-square-o" />
      ) : (
        <i className="icon-attachment" />
      )}
      {attachment.get('title') || attachment.get('filename')}
    </a>
  </div>
);

Attachment.propTypes = {
  attachment: ImmutablePropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
    filename: PropTypes.string,
    attachment_type: PropTypes.string,
  }),
  onClick: PropTypes.func,
};

export default Attachment;
